var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlane(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 90,
    viewBox: "0 0 127 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5351 37.2805L0.231554 61.4044L88.5661 50.3178L102.269 63.9263L92.5351 37.2805Z",
    fill: "#BEB58E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.269 63.9263L84.5972 63.355L88.5661 50.3178L102.269 63.9263Z",
    fill: "#716B44"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.8587 13.377L4.97298 59.6486L92.1451 36.8654L99.8587 13.377Z",
    fill: "#EEECDB",
    stroke: "#BEB58E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.23499 61.5319L79.7172 77.7814L87.8647 50.9094L3.23499 61.5319Z",
    fill: "#EEECDB",
    stroke: "#BEB58E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0736 56.4083C40.7028 62.5263 48.3785 67.7941 57.7635 68.1362C72.1349 68.66 78.6767 60.0226 78.6767 51.5529L40.0736 56.4083Z",
    fill: "#FFD84E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.4068 67.1559L78.8001 73.9995",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1486 55.8631L84.9769 56.0845",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5339 61.0989L36.3312 59.1007",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4135 69.3888L56.2711 71.7669",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8942 64.7191L38.7743 67.9313",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4481 40.4406C75.3764 35.8742 67.8105 37.1849 60.6468 39.0662C54.8843 40.5795 43.4779 45.9813 42.0476 50.4789L80.4481 40.4406Z",
    fill: "#FFD84E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M80.4481 51.3277C81.2601 49.4455 81.3892 43.7251 80.4481 40.4406L42.0476 50.4789C41.5993 52.4391 41.6904 54.9771 42.0474 56.1501L80.4481 51.3277Z",
    fill: "#C5992A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M76.6433 35.2392L82.222 27.0553",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3057 44.5522L42.7771 46.2079",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M50.2362 38.7246L51.3661 40.3602",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M63.4915 33.2474L63.467 35.7032",
    stroke: "#FFCD4E",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1045 29.746C90.33 29.9815 90.9443 30.7293 91.7188 30.4938C92.3705 30.1088 91.879 29.5105 91.1045 29.746Z",
    fill: "#E0CAEF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M75.6886 28.0807C75.3348 28.1883 75.6154 28.5299 75.9692 28.4223C76.2669 28.2464 76.0424 27.9731 75.6886 28.0807Z",
    fill: "#E0CAEF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7983 61.4342C80.0237 61.6697 80.638 62.4175 81.4125 62.182C82.0642 61.797 81.5728 61.1988 80.7983 61.4342Z",
    fill: "#E0CAEF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M85.0658 34.9499C84.8076 35.0284 84.8076 35.0284 85.0658 34.9499C84.4016 35.7125 86.0611 35.7687 86.2089 35.163C86.2089 35.163 86.0859 35.0135 86.3441 34.935C86.6147 34.4789 85.0782 34.5723 85.0658 34.9499Z",
    fill: "#E0CAEF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7444 51.9887C23.4862 52.0672 23.4862 52.0672 23.7444 51.9887C23.0803 52.7513 24.7397 52.8075 24.8875 52.2019C24.8875 52.2019 24.7646 52.0523 25.0227 51.9738C25.2934 51.5177 23.7568 51.6111 23.7444 51.9887Z",
    fill: "#E0CAEF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1244 60.7898C18.8616 60.7771 18.8616 60.7771 19.1244 60.7898C18.0349 61.5281 19.311 62.3808 19.8748 61.6171C19.8748 61.6171 19.8875 61.354 20.1503 61.3667C20.7014 60.8661 19.4127 60.2764 19.1244 60.7898Z",
    fill: "#E0CAEF"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M88.8499 22.2192C88.5917 22.2977 88.5917 22.2977 88.8499 22.2192C88.1858 22.9818 89.8453 23.038 89.993 22.4323C89.993 22.4323 89.8701 22.2828 90.1283 22.2043C90.3989 21.7482 88.8624 21.8416 88.8499 22.2192Z",
    fill: "#E0CAEF"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7666 64.4466C28.9781 64.4084 28.9272 65.4606 29.7157 65.4988C30.5042 65.5369 30.5551 64.4847 29.7666 64.4466Z",
    fill: "#E0CAEF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M70.7681 30.025C69.7831 29.9773 69.7195 31.2917 70.7045 31.3393C71.6895 31.387 71.7531 30.0726 70.7681 30.025Z",
    fill: "#E0CAEF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M69.4325 71.2408C68.644 71.2026 68.5931 72.2548 69.3816 72.2929C70.1701 72.3311 70.221 71.2789 69.4325 71.2408Z",
    fill: "#E0CAEF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0852 48.9264C35.3106 49.1619 35.8021 49.7601 36.5766 49.5246C37.3511 49.2892 36.8597 48.691 36.0852 48.9264Z",
    fill: "#E0CAEF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlane);
export default __webpack_public_path__ + "static/media/plane.9733d47fdacd350ee3abf4d52003fe5b.svg";
export { ForwardRef as ReactComponent };